<template>
    <section class="bg-background-light py-20 lg:py-28" :id="id">
        <div class="mx-auto max-w-[1200px] px-6 lg:px-10">
            <!-- Three-word thesis -->
            <h2 class="text-text-main text-5xl font-black leading-[0.95] tracking-[-0.03em] sm:text-7xl lg:text-[5.5rem]">
                {{ t('why.word1') }}<br />
                {{ t('why.word2') }}<br />
                <span class="text-primary">{{ t('why.word3') }}</span>
            </h2>
            <p class="mt-6 max-w-[560px] text-lg text-text-muted">{{ t('why.subtitle') }}</p>

            <!-- Bento -->
            <div class="mt-12 grid grid-cols-1 gap-5 lg:grid-cols-3">
                <!-- Featured AI card -->
                <article class="group relative col-span-1 overflow-hidden rounded-3xl border border-primary/20 bg-gradient-to-br from-primary/15 via-primary/5 to-transparent p-8 lg:col-span-2">
                    <div class="relative z-10 flex h-full flex-col">
                        <span class="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary text-text-main shadow-[0_10px_30px_-10px_rgba(255,174,0,0.8)]">
                            <span class="material-symbols-outlined">smart_toy</span>
                        </span>
                        <h3 class="mt-6 max-w-[420px] text-2xl font-black tracking-tight text-text-main">{{ t('why.f4_title') }}</h3>
                        <p class="mt-3 max-w-[440px] text-text-muted">{{ t('why.f4_text') }}</p>

                        <!-- tag cloud as a small product detail -->
                        <div class="mt-auto flex flex-wrap gap-2 pt-8">
                            <span v-for="tag in aiTags" :key="tag" class="rounded-full border border-text-main/10 bg-white/70 px-3 py-1 text-xs font-semibold text-text-main">{{ tag }}</span>
                        </div>
                    </div>
                    <div class="pointer-events-none absolute -right-10 -top-10 h-48 w-48 rounded-full bg-primary/30 blur-3xl transition-transform duration-700 group-hover:scale-125"></div>
                </article>

                <FeatureCard icon="payments" :title="t('why.f1_title')" :text="t('why.f1_text')" />
                <FeatureCard icon="forum" :title="t('why.f2_title')" :text="t('why.f2_text')" />

                <article class="col-span-1 flex flex-col justify-between rounded-3xl border border-text-main/10 bg-text-main p-8 text-white lg:col-span-2">
                    <span class="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary text-text-main">
                        <span class="material-symbols-outlined">verified</span>
                    </span>
                    <div class="mt-6">
                        <h3 class="text-xl font-bold">{{ t('why.f3_title') }}</h3>
                        <p class="mt-2 max-w-[440px] text-white/70">{{ t('why.f3_text') }}</p>
                    </div>
                </article>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import FeatureCard from './partials/FeatureCard.vue';

defineProps<{ id?: string }>();

const { t } = useI18n();

const aiTags = ['LLM', 'RAG', 'Automatisering', 'Voorspelling', 'Agents'];
</script>
